import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{staticClass:"d-flex",class:{ 'drawer-link-active': _vm.isActive },attrs:{"link":""},on:{"click":_vm.goToLink}},[(!_vm.subgroup)?_c(VListItemIcon,[_c(VIcon,[_vm._v(" "+_vm._s(_vm.menu.icon)+" ")])],1):_vm._e(),_c(VListItemTitle,{staticClass:"font-weight-regular",class:_vm.subgroup ? 'ml-11' : 'ml-n4'},[_vm._v(" "+_vm._s(_vm.menu.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }